import React, { useCallback, useState, useEffect } from 'react';
import styled from '../../../../styled';
import Text from '../../../text';
import { ColumnButton } from '../../date/Calendar/Column';
import dayjs from '../../date/day';
import { HOUR_FORMAT, getDefaultTimeText } from '..';
const Container = styled.div `
  display: flex;
`;
const Grid = styled.div `
  width: 3.75rem;
  max-height: 17.875rem;
  overflow-y: scroll;

  &:nth-of-type(2) {
    border-left: 0.0625rem solid ${({ theme }) => theme.colors.INK_200};
  }
`;
const Column = styled(ColumnButton) `
  width: 100%;
  height: 2.755rem;

  :hover {
    border-radius: 0;
  }
`;
const Header = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  border-bottom: 0.0625rem solid ${({ theme }) => theme.colors.INK_200};

  > span {
    font-weight: 600;
  }
`;
const getHourString = (hour) => hour.toString().padStart(2, '0');
const TimeSelector = ({ lang, format, inputValue, selectedDate, onSelect, }) => {
    const hours = new Array(12).fill(null).map((_, i) => i + 1);
    const [selectedMode, setSelectedMode] = useState();
    const [selectedHour, setSelectedHour] = useState();
    const isDisabled = !inputValue;
    const handleSelect = useCallback((mode, hour) => {
        if (!hour || !mode)
            return;
        let targetHour = hour;
        if (mode === 'AM' && hour === 12) {
            targetHour = 0;
        }
        else if (mode === 'PM' && hour !== 12) {
            targetHour = hour + 12;
        }
        const date = selectedDate ||
            dayjs(lang, inputValue, format.replace(` ${HOUR_FORMAT}`, ''));
        onSelect(date.hour(targetHour));
        setSelectedMode(undefined);
        setSelectedHour(undefined);
    }, [format, inputValue, lang, onSelect, selectedDate]);
    const handleModeClick = useCallback((mode) => () => {
        if (isDisabled)
            return;
        setSelectedMode(mode);
        handleSelect(mode, selectedHour);
    }, [handleSelect, isDisabled, selectedHour]);
    const handleHourClick = useCallback((hour) => () => {
        if (isDisabled)
            return;
        setSelectedHour(hour);
        handleSelect(selectedMode, hour);
    }, [handleSelect, isDisabled, selectedMode]);
    useEffect(() => {
        // update state when props updated
        if (selectedDate && dayjs(lang, inputValue, format).isValid()) {
            const hour = selectedDate.hour();
            setSelectedMode(hour < 12 ? 'AM' : 'PM');
            setSelectedHour(hour === 0 || hour > 12 ? Math.abs(hour - 12) : hour);
        }
        else if (isDisabled) {
            setSelectedMode(undefined);
            setSelectedHour(undefined);
        }
    }, [lang, format, inputValue, selectedDate, isDisabled]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(Text, { lang: lang, fontType: "Subheading", color: "INK_800" }, getDefaultTimeText(lang))),
        React.createElement(Container, null,
            React.createElement(Grid, null, hours.map((hour) => (React.createElement(Column, { key: `${selectedMode}-${hour}`, isSelected: hour === selectedHour, isDisabled: isDisabled, onClick: handleHourClick(hour) }, getHourString(hour))))),
            React.createElement(Grid, null,
                React.createElement(Column, { isSelected: selectedMode === 'AM', isDisabled: isDisabled, onClick: handleModeClick('AM') }, "am"),
                React.createElement(Column, { isSelected: selectedMode === 'PM', isDisabled: isDisabled, onClick: handleModeClick('PM') }, "pm")))));
};
export default TimeSelector;
//# sourceMappingURL=TimeSelector.js.map